import getJson from '@api/api_helper';

// updateFetchControllers receives the AbortController so a caller typing quickly can cancel
// the request it just superseded. Without it a slow earlier response can land after a newer
// one and repopulate the dropdown with suggestions for a prefix the user has moved past.
export default ({ resourceKey, query, collection, sectionKeys, nls }, updateFetchControllers) => {
  const resource = collection ? 'collections' : 'brandfolders';
  const url = `/api/v3/${resource}/${resourceKey}/autosuggest_search`;

  // api_helper appends params to the URL without escaping them, so the term has to arrive
  // pre-encoded or a phrase containing & or # would truncate the query.
  const params = { term: encodeURIComponent(query) };
  if (sectionKeys?.length) { params.section_keys = sectionKeys.join(','); }
  // nls=true tells the backend to serve phrase completions from the suggestion index.
  // Absence means the caller wants the legacy structured tag:/section: list.
  if (nls) { params.nls = 'true'; }
  return getJson(url, { params }, updateFetchControllers);
};
